var map = {
	"./Banner0.jpg": 321,
	"./Banner1.jpg": 9481,
	"./Banner2.jpg": 7135,
	"./Banner3.jpg": 3058,
	"./Banner4.jpg": 987,
	"./Banner5.png": 8572,
	"./BannerLogo.webp": 5056,
	"./Heading_Attendance.png": 8243,
	"./Heading_Payments.png": 5673,
	"./Heading_TuitionRates.png": 2933,
	"./Loading.svg": 4808,
	"./Logo.png": 6607,
	"./Staff00 - 2021-05-15.jpg": 7389,
	"./Staff00.jpg": 3266,
	"./Staff01.jpg": 2947,
	"./Staff02.jpg": 3044,
	"./Staff03.jpg": 6507,
	"./Staff04.jpg": 4427,
	"./Staff05.jpg": 5481,
	"./Staff06.jpg": 8523,
	"./Staff07.jpg": 5401,
	"./Staff08.jpg": 8271,
	"./Staff09.jpg": 4157,
	"./Staff10.jpg": 8433
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;